import * as React from "react";
const SvgDownarrows = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={4}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M6.646.432a.417.417 0 1 1 .542.633l-2.917 2.5a.417.417 0 0 1-.542 0l-2.916-2.5a.417.417 0 1 1 .542-.633L4 2.7 6.646.432Z"
    />
  </svg>
);
export default SvgDownarrows;